import { useState } from 'react';

import styled from 'styled-components';

import { PAGES } from 'constants/pages';

import { Header, HeaderTitle } from 'components/Header';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { PageTitle } from 'components/PageTitle';

import { DeliveryZonesList } from './components/DeliveryZonesList';
import { DeliveryZonePopup } from './Popups/DeliveryZonePopup';
import { TotadminPermission } from 'data/__generated__';

export const DeliveryZones = () => {
    const [isCreatePopupOpen, setIsCreatePopupOpen] = useState<boolean>(false);

    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.deliveryZones} />
                </HeaderTitle>
                <TotemPrimaryButton
                    onClick={() => setIsCreatePopupOpen(true)}
                    requiredPermissions={[TotadminPermission.DeliveryZonesManage]}
                >
                    Créer une zone
                </TotemPrimaryButton>
            </Header>
            <DeliveryZonesList />
            <DeliveryZonePopup isOpen={isCreatePopupOpen} setIsOpen={setIsCreatePopupOpen} />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;
